<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="success"
    @close="onCloseClick"
  >
    <h3 class="status-dialog__title">试用开通成功</h3>
    <p class="status-dialog__desc">
      您的试用有效期为
      <span class="status-dialog__emphasis">{{ trialDays }}</span>
      天，请在试用到期前购买正式服务
    </p>
    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn status-dialog__btn--purchase"
        :disabled="showRealnameHint"
        @click="onPurchaseClick"
      >
        购买服务
      </button>
      <button
        v-if="showRealnameHint"
        type="button"
        class="status-dialog__btn status-dialog__btn--primary"
        @click="onVerifyClick"
      >
        去实名 &gt;
      </button>
    </div>
    <p v-if="showRealnameHint" class="status-dialog__tip">
      购买正式服务前请先进行实名认证
    </p>
  </StatusDialog>
</template>

<script>
import { shouldShowRealnameHint } from '../realname/realnameService';

export default {
  name: 'SubscriptionTrialSuccessDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    trialDays: {
      type: Number,
      default: 14,
    },
  },

  computed: {
    /** 是否展示「请先实名」提示（未实名时禁用购买） */
    showRealnameHint() {
      return shouldShowRealnameHint();
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  methods: {
    onCloseClick() {
      this.dialogVisible = false;
      this.$emit('close');
      this.$emit('confirm');
    },

    onVerifyClick() {
      this.$emit('verify');
    },

    onPurchaseClick() {
      if (this.showRealnameHint) {
        return;
      }
      this.dialogVisible = false;
      this.$emit('purchase');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/subscriptionService/TrialSuccessDialog.vue